import { controls, currencyToNumber, grouped } from "../../controls";

const talukas_data_entry_status = {
  label: "Talukas Data Entry Status",
  starting: true,
  url: "talukas_data_entry_status",
  pageLabel: "Talukas Data Entry Status",
  pageType: "history",
  filteraction: true,
  filter: [

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Talukas Data Entry Status",
    filterable: true,
    sortable: true,
    pivotable: true,
    //defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",

    },
    // pivot: true,
    extraRows: {
      location: "top",
      fields: ["Rural", "Urban", "total"],
      grandtotal: { type: "fixed", displayIn: "taluka_display", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Taluka",
        accessor: "taluka_display"
      },

      {
        Header: "Rural",
        accessor: "Rural",
        rwidth: "*",

      },
      {
        Header: "Urban",
        accessor: "Urban",
      },
      {
        Header: "Total",
        accessor: "total",
      },




    ]
  }
};

export default talukas_data_entry_status;